import { Box, Text, Flex, Icon } from '@chakra-ui/react';
import { MdFolder as FolderIcon } from 'react-icons/md';
import type { ImportView } from './ImportSheet';
import { TABS } from './importTabConfig';

interface ImportTabBarProps {
  view: ImportView;
  onTabChange: (tab: ImportView | 'manual') => void;
}

export default function ImportTabBar({ view, onTabChange }: ImportTabBarProps) {
  const isCollectionActive = view === 'collection';

  return (
    <Flex gap={2} w="100%" align="stretch">
      {TABS.map((tab) => {
        const isActive = tab.key === view;
        return (
          <Box
            key={tab.key}
            as="button"
            flex={1}
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={1.5}
            py={3}
            px={2}
            borderRadius="12px"
            bg={isActive ? 'accent.secondarySubtle' : 'bg.surface'}
            color={isActive ? 'accent.secondary' : 'text.muted'}
            border="1px solid"
            borderColor={isActive ? 'accent.secondaryBorder' : 'border.muted'}
            cursor="pointer"
            onClick={() => onTabChange(tab.key as ImportView | 'manual')}
            transition="background 0.12s, color 0.12s"
            _hover={{
              bg: isActive ? 'accent.secondarySubtle' : 'bg.muted',
              color: isActive ? 'accent.secondary' : 'text.primary',
            }}
          >
            <Icon as={tab.icon} boxSize={6} />
            <Text fontFamily="body" fontWeight={isActive ? '600' : '400'} fontSize="12px" lineHeight="1">
              {tab.label}
            </Text>
          </Box>
        );
      })}

      {/* Thin vertical rule separating Collection from import tabs */}
      <Box w="1px" bg="border.muted" borderRadius="1px" alignSelf="stretch" my={1} mx={1} flexShrink={0} />

      {/* Collection tab */}
      <Box
        as="button"
        flex={1}
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={1.5}
        py={3}
        px={2}
        borderRadius="12px"
        bg={isCollectionActive ? 'accent.secondarySubtle' : 'bg.surface'}
        color={isCollectionActive ? 'accent.secondary' : 'text.muted'}
        border="1px solid"
        borderColor={isCollectionActive ? 'accent.secondaryBorder' : 'border.muted'}
        cursor="pointer"
        onClick={() => onTabChange('collection')}
        transition="background 0.12s, color 0.12s"
        _hover={{
          bg: isCollectionActive ? 'accent.secondarySubtle' : 'bg.muted',
          color: isCollectionActive ? 'accent.secondary' : 'text.primary',
        }}
      >
        <Icon as={FolderIcon} boxSize={6} />
        <Text fontFamily="body" fontWeight={isCollectionActive ? '600' : '400'} fontSize="12px" lineHeight="1">
          Collection
        </Text>
      </Box>
    </Flex>
  );
}
